import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../../layouts/LayoutOne";
import HeroSliderTwentyFour from "../../wrappers/hero-slider/HeroSliderTwentyFour";
import BannerTwentyThree from "../../wrappers/banner/BannerTwentyThree";
import TabProductFifteen from "../../wrappers/product/TabProductFifteen";
import BannerTwentyFour from "../../wrappers/banner/BannerTwentyFour";
import CountDownThree from "../../wrappers/countdown/CountDownThree";
import FeatureIconFour from "../../wrappers/feature-icon/FeatureIconFour";
import BlogFeaturedThree from "../../wrappers/blog-featured/BlogFeaturedThree";
import BlogFeatured from "../../wrappers/blog-featured/BlogFeatured";
import TestimonialOne from "../../wrappers/testimonial/TestimonialOne";
import TabProduct from "../../wrappers/product/TabProduct";
import Cover from "../../wrappers/testimonial/Cover";

const HomeBookStoreTwo = () => {
  return (
    <Fragment>
      <MetaTags>
        <title>OZ Rentals | Home</title>
        <meta
          name="description"
          content="Book store home of flone react minimalist eCommerce template."
        />
      </MetaTags>
      <LayoutOne headerTop="visible">
        {/* hero slider */}
        <HeroSliderTwentyFour />
        {/* banner */}
        <BannerTwentyThree spaceTopClass="pt-60" />
        <div style={{marginTop:"5%"}} ></div>
        {/* tab product */}
        {/* <TabProductFifteen category="book" spaceTopClass="pt-95" /> */}
        <TabProduct spaceBottomClass="pb-60" category="fashion" />
        {/* banner */}
        <BannerTwentyFour spaceTopClass="pt-100" />
        {/* countdown */}
        {/* <CountDownThree
          spaceTopClass="pt-70"
          spaceBottomClass="pb-95"
          dateTime="November 13, 2021 12:12:00"
          countDownImage="/assets/img/banner/deal-8.png"
        /> */}
        {/* feature icon */}
        <div style={{marginTop:"5%"}} ></div>
        <FeatureIconFour
          spaceBottomClass="pb-90"
          containerClass="container"
          responsiveClass="res-mrg-md-mt"
        />

         {/* testimonial */}
         <TestimonialOne
          spaceTopClass="pt-100"
          spaceBottomClass="pb-95"
          // spaceLeftClass="ml-70"
          // spaceRightClass="mr-70"
          bgColorClass="bg-gray-3"
        />
        {/* <div style={{marginTop:"5%"}} ></div> */}
        <Cover
          spaceTopClass="pt-100"
          spaceBottomClass="pb-95"
          sliderClass="swiper-slide"
          // spaceLeftClass="ml-70"
          // spaceRightClass="mr-70"
          // bgColorClass="bg-gray-3"
        />

        {/* blog featured */}
        {/* <BlogFeaturedThree spaceBottomClass="pb-70" /> */}
        {/* <BlogFeatured spaceBottomClass="pb-55" /> */}
      </LayoutOne>
    </Fragment>
  );
};

export default HomeBookStoreTwo;
